module.exports = __webpack_public_path__ + "static/img/cj1@2x.5039aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cj1@2x.png
// module id = NJ6q
// module chunks = 1